export const DELIVERY_CHALLAN_CREATE_DRAFT_KEY = 'deliveryChallanCreateDraft';
export const DELIVERY_CHALLAN_EDIT_DRAFT_KEY = 'deliveryChallanEditDraft';

export function saveFormDraft(key, data) {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
    sessionStorage.setItem(`${key}:restore`, '1');
  } catch (e) {
    // Ignore quota / private-mode failures.
  }
}

export function peekFormRestore(key) {
  try {
    return sessionStorage.getItem(`${key}:restore`) === '1';
  } catch (e) {
    return false;
  }
}

export function loadFormDraft(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearFormDraft(key) {
  try {
    sessionStorage.removeItem(key);
    sessionStorage.removeItem(`${key}:restore`);
  } catch (e) {
    // Ignore storage failures.
  }
}

/** Clear draft(s) and open a fresh create form (forces remount via ?new=). */
export function navigateToNewForm(navigate, path, draftKeys = []) {
  (Array.isArray(draftKeys) ? draftKeys : [draftKeys]).filter(Boolean).forEach(clearFormDraft);
  const base = String(path || '').split('?')[0];
  navigate(`${base}?new=${Date.now()}`);
}

export function readInitialFormDraft(key) {
  if (!peekFormRestore(key)) {
    return null;
  }
  return loadFormDraft(key);
}
